import React, { createContext, useState } from "react";
import { ISearchConfigContext } from "./searchProviderTypes";
import { WorkSpaceItemListFileConfigSearch } from "../../pages/WorkSpaceItem/WorkSpaceItemListFile";
import { WorkSpaceUserName } from "../../model/ItemModel";
import { GetOneWorkSpace } from "../../services/WorkSpaceServices";
import { WorkSpaceUpdate } from "../../model/WorkSpaceModel";

interface ISearchConfigProvider {
    children: React.ReactNode;
}

export const SearchConfigContext = createContext<ISearchConfigContext>({} as ISearchConfigContext);

export const SearchConfigProvider: React.FC<ISearchConfigProvider> = ({
    children
}) => {
    const [configSearch, setconfigSearch] = useState<WorkSpaceItemListFileConfigSearch | undefined>(undefined)
    const [workspaces, setWorkspaces] = useState<WorkSpaceUserName[] | undefined>([]);
    const [searchTerm, setSearchTerm] = useState<string>("");

    return (
        <SearchConfigContext.Provider
            value={{
                setconfigSearch,
                configSearch,
                setWorkspaces,
                workspaces,
                setSearchTerm,
                searchTerm
            }}
        >
            { children }
        </SearchConfigContext.Provider>
    )

}